import { Container, Link } from "@material-ui/core";
import React from "react";
import "./FooterComponentBlock.scss";
import translate from "../../../i18n/translate";
import { useSelector } from "react-redux";
import { termsOfUse } from "../../../globalConstants";
import { getCookieValue } from "../../../cookieHelper";
const FooterComponentBlock: React.FC = () => {
  const allInfo = useSelector((state: any) => state);

  const getCurrentYear = () => {
    return new Date() ? (new Date().getFullYear() || "-") : "--";
  }

  const openTermsWindow = () => {
    let termsUrl: any = process.env.REACT_APP_TERMS_OF_SERVICE;
    if (allInfo.common.isUserAuthenticated) {
      const uLang = getCookieValue("ulang");
      const lang: any = termsOfUse.find((x: any) => x.key === uLang);
      if (lang?.val) termsUrl = `${process.env.REACT_APP_LEARNSHIP_BASE_URL}${lang?.val}/termsofuse`
    }
    window.open(termsUrl);
  };

  return (
      <Container>
        <div className="footer-container">
          <div className="footer-column">
            <Link color="inherit" href="https://www.learnship.com/us/" target="_blank"><img className="footer-logo"
              src={window.location.origin + "/images/logos/Learnship-main-logo.svg"}
              alt="Learnship logo"
              title="Learnship footer logo"                
            /></Link>
          </div>
          <div className="footer-column footer-menu">
            <Link color="inherit" className="footer-link" href="https://www.learnship.com/en/about-learnship/" target="_blank">{translate("about")}</Link>
            <Link color="inherit" className="footer-link" href="https://www.learnship.com/us/legal-notice/" target="_blank">{translate("legal")}</Link>
            <Link color="inherit" className="footer-link" href="https://www.learnship.com/us/privacy-notice/" target="_blank">{translate("privacy_policy")}</Link>
            <Link color="inherit" data-testid="terms-link" className="footer-link" href="#" onClick={openTermsWindow} target="_blank">{translate("Terms_conditions")}</Link>
            {/* <Link href="http://beian.miit.gov.cn" target="_blank">沪ICP备14032085号-1</Link> */}
          </div>
          <div className="footer-column footer-copyright">&#169; 2010 - {getCurrentYear()}</div>
        </div>
      </Container>
  );
};

export default FooterComponentBlock;
